import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'

import './index.css'

import Table from '../../helpers/Table'

import { fetchApprovalTypes, fetchApprovals, fetchMaterialBrands, fetchMaterialCategories } from '../../services/redux/reducers/commonThunk'

import { getApprovalParams, getFullName, numberConversion } from '../../utils'


const ApprovalsChart = () => {
	const approvals = useSelector(state => state.common.approvals)
	const approvalTypes = useSelector(state => state.common.approvalTypes)

	const materialBrands = useSelector(state => state.common.materialBrands)
	const materialCategories = useSelector(state => state.common.materialCategories)

	const userDetails = useSelector(state => state.userDetails)
	const activeUserRole = userDetails.activeUserRoleDetails

	const companyUsers = userDetails.PMCompanyDetails.companyUsers
	const companyRoles = userDetails.PMCompanyDetails.companyRoles

	const sortedApprovals = _.sortBy(approvals, "approvalTypeId")

	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(fetchApprovals())
		dispatch(fetchApprovalTypes())
		dispatch(fetchMaterialBrands())
		dispatch(fetchMaterialCategories())
	}, [approvalTypes])

	const getApprovalType = (row) => {
		const relatedApprovalType = approvalTypes.find(eachApprovalType => eachApprovalType.approvalTypeId === row.approvalTypeId)
		return (
			<div className='doc-no'>
				{relatedApprovalType ? relatedApprovalType.approvalType : "Unknown Type"}
			</div>
		)
	}

	const getPrimaryApprover = (row) => {
		if (row.approvalRole === "COMPANY ROLE"){
			const relatedCompanyRole = companyRoles.find(eachCompanyRole => eachCompanyRole.companyRoleId === row.primaryApprover)
			return (
				relatedCompanyRole ? relatedCompanyRole.companyRoleName : "-"
			)
		}
		if (row.approvalRole === "USER"){
			const relatedCompanyUser = companyUsers.find(eachCompanyUser => eachCompanyUser.userId === row.primaryApprover)
			return (
				relatedCompanyUser ? 
				<a href={`https://portal.procmart.com/edituser/${relatedCompanyUser.userId}`} target='_blank' style={{textDecoration: 'none', cursor: "pointer"}}>{getFullName(relatedCompanyUser.firstName, relatedCompanyUser.lastName)}</a> 
				: 
				"-"
			)
		}
		if (row.approvalRole === "MANAGER"){
			const relatedUserManager = companyUsers.find(eachCompanyUser => eachCompanyUser.userId === activeUserRole.managerId)
			return (
				relatedUserManager ? <a>{getFullName(relatedUserManager.firstName, relatedUserManager.lastName)}</a> : "MANAGER"
			)
		}
	}

	const renderParams = (approvalParamTitle, approvalParamValue) => {
		return (
			<div style={{ padding: '3px 6px', borderRadius: '3px' }}>
				<span style={{ fontWeight: 'bold' }}>{approvalParamTitle} : </span>
				<span style={{ fontWeight: 'normal', fontSize: '14px' }}>{approvalParamValue}</span>
			</div>
		)
	}

	const getLimitsBody = (row) => {
		const approvalParams = getApprovalParams(row)

		let htmlArr = []

		if (approvalParams.brand_id){
			const relatedMaterialBrand = materialBrands.find(eacMaterialBrand => eacMaterialBrand.brandId === approvalParams.brand_id)
			htmlArr.push(renderParams("BRANDS", relatedMaterialBrand?.brandName))
		}

		if (approvalParams.category_ids.length){
			const relatedMaterialCategories = materialCategories.filter(eachMaterialCategory => approvalParams.category_ids.includes(eachMaterialCategory.categoryId))
			const materialCategoriesNames = relatedMaterialCategories.map(eachMaterialCategory => eachMaterialCategory.categoryName)
			htmlArr.push(renderParams("CATEGORIES", materialCategoriesNames.join(", ")))
		}

		if (isFinite(approvalParams.lowerLimit) && approvalParams.lowerLimit > 0){
			htmlArr.push(renderParams("LOWER LIMIT", numberConversion(approvalParams.lowerLimit)))
		}

		if (isFinite(approvalParams.upperLimit) && approvalParams.upperLimit > 0){
			htmlArr.push(renderParams("UPPER LIMIT", numberConversion(approvalParams.upperLimit)))
		}

		return (
			<>{htmlArr.length ? htmlArr : "-"}</>
		)
	}

	const tableColumns = [
		{
			header: 'Approval Type',
			field: "approvalTypeId",
			body: getApprovalType,
			style: { textAlign: 'center', minWidth: '200px' }
		},
		{
			header: 'Approval Title',
			field: 'approvalTitle',
			style: { textAlign: 'center', minWidth: '200px' }
		},
		{
			header: 'Approval Authority',
			field: 'approvalRole',
			style: { textAlign: 'center', minWidth: '180px' }
		},
		{
			header: 'Parameters',
			body: getLimitsBody,
			style: { textAlign: 'center', maxWidth: '550px' }
		},
		{
			header: 'Primary Approver',
			body: getPrimaryApprover,
			style: { textAlign: 'center', minWidth: '150px' }
		}
	]

	return (
		<div>
			<div className="vp-cheque-layout flex flex-column">
				<div className="flex justify-content-between">
					<h4 className="m-2">APPROVALS CHART</h4>
				</div>

				<div className='flex flex-row'>
					<div className="requirement-table" style={{ order: "1", width: "100%" }}>
						<div className='p-card mb-0'>
							<div className="flex-grow-1" >
								<Table
									lazy
									tableColumns={tableColumns}
									data={sortedApprovals}
									paginator={false}
									rowGroupMode="rowspan"
									groupRowsBy="approvalTypeId"
									sortMode="single"
									sortField="approvalTypeId"
									sortOrder="1"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ApprovalsChart